<template>
    <el-container id="tab">
        <el-main>
            <el-card shadow="never" class="box-card">
                <div>
                    <span style="display: inline-block; width: 65px; font-size: 14px;">商品名称</span>
                    <select-multiple style="width: 260px;" v-bind:select-data="searchProduct"></select-multiple>
                    <el-button style="margin-left: 10px;" size="small" type="primary" @click="getTableData">查询</el-button>
                </div>
                <el-button size="small" @click="addProduct('')">添加</el-button>
            </el-card>
            <div class="table">
                <el-table v-loading="tableLoading" class="tb-edit" ref="table" :data="tableData" border stripe height="100%" max-height="100%" style="width: 100%" @row-dblclick="rowDblclick">
                    <el-table-column type="index" align="center" width="45"></el-table-column>
                    <el-table-column label="主品" prop="mainItemName"></el-table-column>
                    <el-table-column prop="composeItemName" label="组合品" min-width="140px"></el-table-column>
                    <el-table-column prop="isEnabled" label="状态" width="100">
                        <template slot-scope="scope">
                            <span>{{scope.row.isEnabled == 'Y' ? '可用':'停用'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-tooltip :hide-after="2000" class="item" effect="dark" :content="scope.row.isEnabled == 'N' ? '启用':'停用'" placement="top">
                                <el-button icon="el-icon-warning-outline" type="text" @click="stopRow(scope.row)"></el-button>
                            </el-tooltip>
                            <el-tooltip :hide-after="2000" class="item" effect="dark" content="编辑" placement="top">
                                <i class="iconfont icon-bianji" @click="addProduct(scope.row.seqNo, 1)"></i>
                            </el-tooltip>
                            <el-tooltip :hide-after="2000" class="item" effect="dark" content="删除" placement="top">
                                <el-button icon="el-icon-delete" type="text" @click="clearRow(scope.row, 'tableData')" style="margin: 0;"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-main>
        <el-dialog :visible.sync="productVisible" width="60%" center class="product-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
            <div v-loading="productLoading" class="table productTable">
                <p style="font-size: 16px; line-height: 24px; color: #F56C6C">* 请先选择主品</p>
                <el-table :data="mainData" ref="mainTable" border stripe height="135px" style="width: 100%; margin-bottom: 10px;" @cell-click="mainTableClick">
                    <el-table-column type="index" align="center" width="40"></el-table-column>
                    <el-table-column label="操作" align="center" width="50">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-delete" type="text" @click="deleteRow(scope, 'mainData')" style="margin: 0;"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="itemName" label="主品" align="center" min-width="140px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isShowItemName">
                                <select-multiple style="width: 99%;" :select-data="itemName" :optionKey="itemNameOptionKey" :isSlot="true" :isClear="false" :change="(val, row) => { itemNameChange(val, scope, 'unitName', 'mainData') }" :visible-change="(val, row) => { itemNameVisibleChange(val, scope, 'unitName', 'mainData') }" v-focus>
                                    <template #header>
                                        <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                            <span style="width: 180px;display: inline-block;">商品</span>
                                            <span style="width: 100px;display: inline-block;">规格</span>
                                        </li>
                                    </template>
                                    <template v-slot:default='slotProps'>
                                        <div style="flex: 1; display: flex; align-items: center;">
                                            <span style="width: 180px;text-wrap: initial;word-wrap:break-word;word-break:break-all;white-space:normal;">{{ slotProps.item.itemName }}</span>
                                            <span style="width: 100px;display: inline-block;">{{ slotProps.item.itemSpec }}</span>
                                        </div>
                                    </template>
                                </select-multiple>
                            </div>
                            <div v-else>
                                <span>{{ scope.row.itemName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitName" align="center" label="单位" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.itemName">
                                <div v-if="scope.row.isShowUnitName">
                                    <el-select size="small" v-model="scope.row.unitObj" placeholder="请选择单位" value-key="value" @change="selectChange($event, scope, 'unitName', 'qty', 'mainData')" @keydown.enter.native="numberInputBlur('', scope, 'unitName', 'qty', 'mainData')" @visible-change="selectVisibleChange($event, scope, 'qty', 'mainData')" v-focus automatic-dropdown>
                                        <el-option v-for="item in scope.row.unitArr" :key="item.text" :label="item.text" :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <span v-else>{{scope.row.unitName}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="qty" label="数量" align="center" width="140">
                        <template slot-scope="scope">
                            <div v-if="scope.row.itemName">
                                <el-input-number size="small" v-if="scope.row.isShowQty" style="width: 99%;" v-focus v-model.number="scope.row.qty" :controls="false" :min="0" @blur="numberInputBlur($event, scope, 'qty', '', 'mainData')" @keydown.enter.right.native="numberInputBlur('', scope, 'qty', 'itemName', 'mainData')"></el-input-number>
                                <span v-else style="width: 99%; display: inline-block; text-align: center;">{{Number(scope.row.qty) || 0}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="costPrice" align="center" label="成本价" width="100" v-if="allowCostPrice"></el-table-column>
                    <el-table-column prop="totalAmt" label="总价" align="center" width="140" v-if="allowCostPrice"></el-table-column>
                </el-table>
                <el-table :data="productData" ref="productTable" border stripe style="width: 100%;" height="291px" @cell-click="tableCellClick">
                    <el-table-column type="index" align="center" width="40"></el-table-column>
                    <el-table-column label="操作" align="center" width="60">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-plus" type="text" :style="scope.$index + 1 == productData.length ? 'color: red' : ''" @click="addRow(scope.$index + 1)"></el-button>
                            <el-button icon="el-icon-delete" type="text" @click="deleteRow(scope, 'productData')" style="margin: 0;"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="itemName" label="组合品" align="center" min-width="140px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isShowItemName">
                                <select-multiple style="width: 99%;" :select-data="itemName" :optionKey="itemNameOptionKey" :isSlot="true" :isClear="false" :change="(val, row) => { itemNameChange(val, scope, 'unitName', 'productData') }" :visible-change="(val, row) => { itemNameVisibleChange(val, scope, 'unitName', 'productData') }" v-focus>
                                    <template #header>
                                        <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                            <span style="width: 180px;display: inline-block;">商品</span>
                                            <span style="width: 100px;display: inline-block;">规格</span>
                                        </li>
                                    </template>
                                    <template v-slot:default='slotProps'>
                                        <div style="flex: 1; display: flex; align-items: center;">
                                            <span style="width: 180px;text-wrap: initial;word-wrap:break-word;word-break:break-all;white-space:normal;">{{ slotProps.item.itemName }}</span>
                                            <span style="width: 100px;display: inline-block;">{{ slotProps.item.itemSpec }}</span>
                                        </div>
                                    </template>
                                </select-multiple>
                            </div>
                            <div v-else>
                                <span>{{ scope.row.itemName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitName" align="center" label="单位" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.itemName">
                                <div v-if="scope.row.isShowUnitName">
                                    <el-select size="small" v-model="scope.row.unitObj" placeholder="请选择单位" value-key="value" @change="selectChange($event, scope, 'unitName', 'qty', 'productData')" @keydown.enter.native="numberInputBlur('', scope, 'unitName', 'qty', 'productData')" @visible-change="selectVisibleChange($event, scope, 'qty', 'productData')" v-focus automatic-dropdown>
                                        <el-option v-for="item in scope.row.unitArr" :key="item.text" :label="item.text" :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <span v-else>{{scope.row.unitName}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="qty" label="数量" align="center" width="140">
                        <template slot-scope="scope">
                            <div v-if="scope.row.itemName">
                                <el-input-number size="small" v-if="scope.row.isShowQty" style="width: 99%;" v-focus v-model.number="scope.row.qty" :controls="false" :min="0" @blur="numberInputBlur($event, scope, 'qty', '', 'productData')" @keydown.enter.right.native="numberInputBlur('', scope, 'qty', 'itemName', 'productData')"></el-input-number>
                                <span v-else style="width: 99%; display: inline-block; text-align: center;">{{Number(scope.row.qty) || 0}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="costPrice" align="center" label="成本价" width="100" v-if="allowCostPrice"></el-table-column>
                    <el-table-column prop="totalAmt" label="总价" align="center" width="140" v-if="allowCostPrice"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="onReset()">重置</el-button>
                <el-button size="small" type="primary" @click="onSubmit()">提交</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>
<script>
import { toFixedRe, getResultArray } from '@/assets/js/common.js'
import selectProduct from '@/components/common/selectProduct.vue'
export default {
    name: "InvMakeSearch",
    components: {
        selectProduct
    },
    data() {
        return {
            isCollapse: false,
            searchProduct: { submitName: 'itemID', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, size: 'small', list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
            tableData: [],
            tableLoading: false,
            productVisible: false,
            productLoading: false,
            productData: this.pushItem(),
            mainData: this.pushItem(1),
            selectProductVisible: false,
            type: 0,
            selectProductList: [],
            mainProduct: { submitName: 'itemName', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, size: 'small', list: [], placeholder: '请选择商品名称', request: { url: '/Account/dataSearchVue/selectItemEnterListForCompose.html', type: 'post', params: { page: 1, size: 5, billType: 'CGD', keyWords: '', }, text: "itemName", value: "itemID" } },
            itemName: {
                submitName: "itemName",
                selected: {},
                valueIsObj: true,
                isMultiple: false,
                isAll: false,
                isShowAll: false,
                isFilterable: true,
                isRemote: true,
                isPagination: true,
                isReSearch: false,
                list: [],
                placeholder: "请选择商品",
                size: 'small',
                request: {
                    url: "/Account/dataSearchVue/selectItemEnterListForCompose.html",
                    type: "post",
                    params: {
                        page: 1,
                        size: 5,
                        billType: 'CGD',
                        keyWords: '',
                        // searchType: 3
                    },
                    text: "itemName",
                    value: "itemID",
                },
            },
            allowCostPrice: false,
            priceArgs: {
                url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
                code: 'isAllocateDisassembly'
            },
            currentSeqNo: ''
        }
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.querySelector('input').onfocus = function(e) {
                    e.currentTarget.select()
                }
                el.querySelector('input').focus()
            }
        }
    },
    watch: {
        productData(val) {
            val.forEach((item, index) => {
                item['lineNum'] = index + 1
            })
        },
        mainData(val) {
            val.forEach((item, index) => {
                item['lineNum'] = index + 1
            })
        },
    },
    created() {
        this.getTableData()
        this.allowCostPrice = this.$store.state.power.allowCostPrice == 'Y'
        if (this.$store.state.power.enterpriseVersion >= 100) {
            this.getPriceShow()
        }
        let unwatch = this.$watch('$store.state.power', (val) => {
            if (val.enterpriseVersion >= 100) {
                this.getPriceShow()
            }
            unwatch()
        })
    },
    methods: {
        async getPriceShow() {
            const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
            console.log(res.result)
            this.allowCostPrice = res.result == 'Y'
            this.$nextTick(() => {
                this.$refs["table"].doLayout();
            });
        },
        async getTableData() {
            this.tableLoading = true
            let url = '/Account/itemComposeDefineVue/selectItemComposeList.html'
            let itemName = !this.searchProduct.selected.text ? '' : this.searchProduct.selected.text
            try {
                const { data: res } = await this.$http.post(url, this.Qs.stringify({ keyWords: itemName }))
                this.tableLoading = false
                if (res.code != 'success') return this.$message.error(res.message)
                this.tableData = JSON.parse(res.result)
            } catch (e) {
                console.log(e)
                this.tableLoading = false
            }
        },
        rowDblclick(row) {
            console.log(row)
            this.addProduct(row.seqNo, 1)
        },
        addProduct(seqNo, type) {
            this.productVisible = true
            this.mainData = this.pushItem(1)
            this.productData = this.pushItem()
            this.selectProductList = []
            this.type = type ? type : 0
            console.log(seqNo)
            this.currentSeqNo = seqNo
            if (seqNo != '') {
                this.getProduct(seqNo)
            }
        },
        async getProduct(seqNo) {
            this.productLoading = true
            let url = '/Account/itemComposeDefineVue/selectItemCompose.html'
            try {
                const { data: res } = await this.$http.post(url, this.Qs.stringify({ seqNo: seqNo }))
                this.productLoading = false
                if (res.code != 'success') return this.$message.error(res.message)
                // this.tableData = JSON.parse(res.result)
                let { composeList, mainList } = JSON.parse(res.result)
                mainList.map(item => {
                    let _unitArr = []
                    if (item.salUnitName) _unitArr.push({ value: 'sal', text: item.salUnitName })
                    if (item.midUnitName) _unitArr.push({ value: 'mid', text: item.midUnitName })
                    if (item.invUnitName) _unitArr.push({ value: 'inv', text: item.invUnitName })
                    item.unitArr = _unitArr
                    item.unitObj = _unitArr.filter(it => it.text == item.unitName)[0]
                    if(item.unitVal == 'inv'){
                        item['costPrice'] = item.invCostPrice1
                    }else if(item.unitVal == 'mid'){
                        item['costPrice'] = item.midCostPrice1
                    }else if(item.unitVal == 'sal'){
                        item['costPrice'] = item.itemCostPrice1
                    }
                    item['totalAmt'] = parseFloat(toFixedRe(Number(item.costPrice * parseInt(item.qty)), 2))
                    return item
                })
                composeList.map(item => {
                    let _unitArr = []
                    if (item.salUnitName) _unitArr.push({ value: 'sal', text: item.salUnitName })
                    if (item.midUnitName) _unitArr.push({ value: 'mid', text: item.midUnitName })
                    if (item.invUnitName) _unitArr.push({ value: 'inv', text: item.invUnitName })
                    item.unitArr = _unitArr
                    item.unitObj = _unitArr.filter(it => it.text == item.unitName)[0]
                    if(item.unitVal == 'inv'){
                        item['costPrice'] = item.invCostPrice1
                    }else if(item.unitVal == 'mid'){
                        item['costPrice'] = item.midCostPrice1
                    }else if(item.unitVal == 'sal'){
                        item['costPrice'] = item.itemCostPrice1
                    }
                    item['totalAmt'] = parseFloat(toFixedRe(Number(item.costPrice * parseInt(item.qty)), 2))
                    return item
                })
                mainList.forEach((item, index) => {
                    this.$set(this.mainData, index, item)
                })
                composeList.forEach((item, index) => {
                    this.$set(this.productData, index, item)
                })
                console.log(this.mainData)
                console.log(this.productData)
            } catch (e) {
                console.log(e)
                this.productLoading = false
            }
        },
        inputChange(val) {
            if (val) {
                val = val.replace(/[^\d]/g, '')
                this.queryForm.num.selected = val
            }
        },
        // 首字母大写
        productChange(val) {
            this.queryForm.product.selected.isMain = 'Y'
            this.queryForm.product.selected.qty = 0
            this.queryForm.product.selected.unitName = ''
            console.log(this.queryForm.product.selected)
        },
        titleCase(str) {
            return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
        },
        tableCellClick(row, { property }, data) {
            console.log(row, property)
            if (property && property.match(/itemName|unitName|qty/i)) {
                if (!this.mainData[0].itemName) return this.$message({
                    showClose: true,
                    message: '请先选择主品',
                    type: 'warning'
                })
                // console.log(row, property)
                // row['isShow' + this.titleCase(property)] = true
                // this.$refs['productTable'].updateData()
                this.$set(row, 'isShow' + this.titleCase(property), true)
            }
        },
        mainTableClick(row, { property }) {
            if (property && property.match(/itemName|unitName|qty/i)) {
                // console.log(row, property)
                // row['isShow' + this.titleCase(property)] = true
                // this.$refs['productTable'].updateData()
                this.$set(row, 'isShow' + this.titleCase(property), true)
            }
        },
        itemNameVisibleChange(val, { $index, row, column }, next, data) {
            if (!val) {
                // this.$set(row, 'isShow' + this.titleCase(column.property), false)
                let tempItem = {}
                tempItem['seqNo'] = this.currentSeqNo
                tempItem['isShow' + this.titleCase(column.property)] = false
                this.$set(this[data], $index, { ...row, ...tempItem })
                this.tableCellClick(this[data][$index], { property: next }, data)
            } else {
                this.itemName.placeholder = row.itemName
                this.itemName.selected = { text: row.itemName, value: row.itemID }
            }
            this.itemName.request.params.page = 1
        },
        selectVisibleChange(isShow, { $index, row, column }, next, data) {
            console.log(isShow, 2222)
            if (!isShow) {
                let tempItem = {}
                tempItem['isShow' + this.titleCase(column.property)] = false
                console.log(column.property, $index)
                this.$set(this[data], $index, { ...row, ...tempItem })
                if (next) {
                    this.tableCellClick(this[data][$index], { property: next })
                }
            }
        },
        numberInputBlur(event, { $index, row }, property, next, data) {
            console.log(event)
            let tempItem = {}
            tempItem['isShow' + this.titleCase(property)] = false
            if(row.qty){
                tempItem['totalAmt'] = parseFloat(toFixedRe(Number(row.costPrice * row.qty), 2))
            }
            console.log('data', data)
            // 有组合品时根据组合品总价计算主品总价,没有组合品是根据主品的单位和数量计算主品的总价
            if(data == 'productData'){
                this.$set(this[data], $index, { ...row, ...tempItem })
                let totalAmt = 0
                this.productData.map((item, index) => {
                    console.log(item)
                    if(item.qty){
                        totalAmt += Number(item.costPrice * item.qty)
                    }
                })
                let costPrice = 0
                if(this.mainData[0].qty){
                    costPrice = parseFloat(toFixedRe(Number(totalAmt / this.mainData[0].qty), 4))
                    totalAmt = parseFloat(toFixedRe(Number(totalAmt), 2))
                }else {
                    costPrice = parseFloat(this.mainData[0].costPrice)
                    totalAmt =  parseFloat(toFixedRe(Number(0), 2))
                }
                let tampObj = {
                    totalAmt: totalAmt,
                    costPrice: costPrice
                }
                this.$set(this.mainData, 0, { ...this.mainData[0], ...tampObj })
            }
            if(data == 'mainData'){
                let list = [...this.productData].filter(item => item.itemID)
                let productTotalAmt = 0
                this.productData.map((item, index) => {
                    if(item.totalAmt){
                        productTotalAmt += Number(item.totalAmt)
                    }
                })
                if(list.length > 0){
                    if(this.mainData[0].qty == undefined) {
                        this.mainData[0].qty = 0
                    }
                    if(this.mainData[0].qty){
                        this.$set(this.mainData, 0, { ...this.mainData[0], ...{costPrice: parseFloat(toFixedRe(Number(productTotalAmt / this.mainData[0].qty), 4)), totalAmt: parseFloat(toFixedRe(Number(productTotalAmt), 2))} })
                    }
                }else {
                    this.$set(this[data], $index, { ...row, ...tempItem })
                }
            }
            if (next) { 
                if (property == 'qty') {
                    if (this[data][$index + 1]) {
                        this.tableCellClick(this[data][$index + 1], { property: next }, data)
                    }
                    return false
                }
                this.tableCellClick(this[data][$index], { property: next }, data)
            }
        },
        selectChange(obj, { $index, row }, property, next, data) {
            console.log(obj)
            let tempItem = {}
            tempItem['isShow' + this.titleCase(property)] = false
            tempItem['unitName'] = obj.text
            tempItem['conversion'] = row[obj.value + 'UnitConversion']
            let list = [...this.productData].filter(item => item.itemID)
            if(data == 'mainData'){
                if(list.length == 0){
                    if(obj.value == 'inv'){
                        tempItem['costPrice'] = row.invCostPrice1
                    }else if(obj.value == 'mid'){
                        tempItem['costPrice'] = row.midCostPrice1
                    }else if(obj.value == 'sal'){
                        tempItem['costPrice'] = row.itemCostPrice1
                    }
                }
            }else {
                if(obj.value == 'inv'){
                    tempItem['costPrice'] = row.invCostPrice1
                }else if(obj.value == 'mid'){
                    tempItem['costPrice'] = row.midCostPrice1
                }else if(obj.value == 'sal'){
                    tempItem['costPrice'] = row.itemCostPrice1
                }
            }
            console.log(tempItem)
            this.$set(this[data], $index, { ...row, ...tempItem })
            if (next) {
                if (property == 'qty') {
                    if (this[data][$index + 1]) {
                        this.tableCellClick(this[data][$index + 1], { property: next }, data)
                    }
                    return false
                }
                this.tableCellClick(this[data][$index], { property: next }, data)
            }
        },
        async itemNameChange(val, { $index, row }, next, data) {
            console.log($index)
            // let rowIndex = 0
            // let tempArr = this.productData.filter((i, index) => {
            //     if (this.itemNameOptionKey(i) == this.itemNameOptionKey(val)) {
            //         rowIndex = index + 1
            //         return true
            //     }
            // })
            // console.log(tempArr, rowIndex)
            // let confirmResult = ''
            // if (tempArr.length) {
            //     const h = this.$createElement
            //     confirmResult = await this.$msgbox({
            //         title: '提示',
            //         message: h('p', null, [
            //             h('i', { style: 'color: teal' }, tempArr[0].itemName),
            //             h('span', null, '第'),
            //             h('i', { style: 'color: #F56C6C' }, rowIndex),
            //             h('span', null, '行已经录入，是否合并?')
            //         ]),
            //         showCancelButton: true,
            //         confirmButtonText: '合并',
            //         type: 'warning'
            //     }).catch(err => err)
            // }
            // if (confirmResult == '') {
            let _unitArr = []
            if (val.salUnitName) _unitArr.push({ value: 'sal', text: val.salUnitName })
            if (val.midUnitName) _unitArr.push({ value: 'mid', text: val.midUnitName })
            if (val.invUnitName) _unitArr.push({ value: 'inv', text: val.invUnitName })
            val.unitArr = _unitArr
            val.qty = 0
            val.unitName = _unitArr[0].text
            val.unitObj = _unitArr[0]
            val.conversion = val[_unitArr[0].value + 'UnitConversion']
            val.isMain = data == 'productData' ? 'N' : 'Y'
            val.costPrice = val.itemCostPrice1
            this.$set(this[data], $index, { ...row, ...val })
            console.log(this[data])
            if (data == 'productData') {
                this.selectProductList = this.selectProductList.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(row))
                // this.selectProductList = this.selectProductList.filter(i => i.value != row.value)
                this.selectProductList.push(val)
            }
            // } else if (confirmResult == 'confirm') {
            this.tableCellClick(this[data][$index], { property: next }, data)
            // }
        },
        itemNameOptionKey(item) {
            return item.itemID + item.productionDate
        },
        pushItem(length) {
            const tempItem = []
            if (!length) length = 6
            for (let i = 0; i < length; i++) {
                tempItem.push({})
            }
            return tempItem
        },
        addRow(index) {
            if (index === this.productData.length) {
                this.productData = this.productData.concat(this.pushItem(3))
            } else {
                this.productData.push({})
            }
        },
        async stopRow({ isEnabled, seqNo }) {
            const confirmResult = await this.$confirm('此操作为' + (isEnabled == 'N' ? '启用' : '停用') + '操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消操作')
            const { data: res } = await this.$http.post('/Account/itemComposeDefineVue/updateItemComposeDisable.html', this.Qs.stringify({ seqNo: seqNo, isEnabled: isEnabled == 'Y' ? 'N' : 'Y' }))
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.getTableData()
        },
        async clearRow({ seqNo }) {
            const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消删除')
            const { data: res } = await this.$http.post('/Account/itemComposeDefineVue/deleteItemCompose.html', this.Qs.stringify({ seqNo: seqNo }))
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.getTableData()
        },
        async deleteRow({ $index, row }, data) {
            if (this[data].length <= 1 && data != 'mainData') return
            console.log(this[data])
            const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消删除')
            if (data == 'mainData') {
                this[data] = this.pushItem(1)
            } else {
                if (row.planID) {
                    this[data] = this[data].filter(item => item.planID != row.planID)
                } else {
                    this[data].splice($index, 1)
                }
                this.tempProductData = [...this.productData].filter(item => item.itemID)
                let tempTotalAmt = 0
                this.tempProductData.map(item => {
                    tempTotalAmt += Number(item.totalAmt)
                })
                tempTotalAmt = parseFloat(toFixedRe(Number(tempTotalAmt), 2), 2)
                let tempCostPrice = parseFloat(toFixedRe(Number(tempTotalAmt), 2), 2)
                let tempMainData = {
                    totalAmt: tempTotalAmt,
                    costPrice: tempCostPrice
                }
                this.$set(this.mainData, 0, { ...this.mainData[0], ...tempMainData })
            }
        },
        async onSubmit() {
            let flag = false
            if (this.mainData[0].itemID && this.mainData[0].unitName && (!this.mainData[0].qty || this.mainData[0].qty == 0)) {
                return this.$message({
                    showClose: true,
                    message: '主品第1行,商品数量不能为零',
                    type: 'error'
                })
            }
            this.productData.some(item => {
                const { itemID, unitName, qty, lineNum } = item
                if (this.type == 1) {
                    item.seqNo = this.mainData[0].seqNo
                }
                if (itemID && unitName && (!qty || qty == 0)) {
                    this.$message({
                        showClose: true,
                        message: '组合品第' + lineNum + '行,商品数量不能为零',
                        type: 'error'
                    })
                    flag = true
                    return true
                }
            })
            if (flag) return
            let list = [...this.productData].filter(item => item.itemID)
            list.unshift(this.mainData[0])
            console.log(list)
            if (!this.mainData[0].itemID) return this.$message({
                showClose: true,
                message: '请选择主品',
                type: 'error'
            })
            if (list.length == 1) return this.$message({
                showClose: true,
                message: '请至少选择一种组合品',
                type: 'error'
            })
            const loading = this.$loading({
                lock: true,
                text: '提交中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = '/Account/itemComposeDefineVue/addItemCompose.html'
            // // ------是否为复制与编辑单据------开始
            if (this.type == 1) {
                url = '/Account/itemComposeDefineVue/updateItemCompose.html'
            }
            // // ------是否为复制与编辑单据------结束
            const { data: res } = await this.$http.post(url, this.Qs.stringify({ itemComposeList: JSON.stringify(list) }))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.productVisible = false
            this.getTableData()
        },
        onReset() {
            this.productData = this.pushItem()
        },
        addProductToOrder(itemList) {
            // if (this.power.activeName == 'first') {
            //   this.tableData.forEach(i => {
            //     itemList = itemList.filter(j => this.itemNameOptionKey(i) != this.itemNameOptionKey(j))
            //   })
            // }
            let tableData = [...this.productData].reverse()
            let length = tableData.length
            this.$nextTick(() => {
                tableData.some((item, index) => {
                    if (item.itemID) {
                        itemList.forEach((row, $index) => {
                            this.$set(this.productData, length - index + $index, row)
                        })
                        return true
                    }
                    if ((this.productData.length - 1) == index) {
                        itemList.map((row, $index) => {
                            this.$set(this.productData, $index, row)
                        })
                        return true
                    }
                })
            })
            return true
        },
        deleteProductToOrder(key, value, itemList = []) {
            this.$nextTick(() => {
                if (itemList.length > 0) {
                    itemList.forEach(item => {
                        // this.productData = this.productData.filter(i => i.itemID != item.itemID)
                        this.productData = this.productData.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(item))
                    })
                } else {
                    this.productData = this.productData.filter(item => item[key] != value)
                }
                this.productData = this.productData.concat(this.pushItem(20 - this.tableData.length))
            })
            return true
        },
    }
};
</script>
<style scoped src="@/assets/font/tableButtonIcon.css"></style>
<style lang="less">
.el-select-group__title~.el-select-dropdown__item {
    height: auto !important;
}
</style>

<style scoped lang="less">
#tab {
    .el-main {
        padding: 0;

        .box-card {

            /deep/.select_multiple{
                width: 100%;
            }

            /deep/.el-card__body {
                padding: 10px 15px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                >div {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
            }

            /deep/.el-form-item {
                margin-bottom: 0;
            }
        }

        .main_footer {
            height: 45px;
            display: flex;
            align-items: center;

            .text {
                color: #F56C6C;
                padding: 0 4px;
                font-size: 14px;
                font-weight: bolder;
            }

            .el-button {
                transform: translate(-50%, 0);
            }
        }
    }

    .product-dialog {
        /deep/.el-dialog {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            top: 50%;
            transform: translateY(-50%);

            .el-dialog__header {
                padding: 10px 0;

                .el-dialog__headerbtn {
                    top: 10px;
                    font-size: 18px;
                }
            }

            .el-dialog__body {
                padding: 20px;
            }

            .el-dialog__footer {
                padding: 0 20px 20px;
            }
        }
    }

    .table {
        height: calc(100% - 54px);

        /deep/.el-table {

            .el-button--text {
                font-size: 16px;
                padding: 0;
            }

            .icon-bianji {
                color: #409EFF;
                margin: 0 6px;
            }

            td,
            th {
                padding: 6px 0;

                .cell {
                    font-size: 14px;
                    padding: 0 6px;

                    span {
                        font-size: 14px;
                    }

                    .select_multiple {
                        width: 100%;
                    }
                }
            }

            .plan-row {
                td {
                    background-color: pink !important;
                }

                &.hover-row {
                    td {
                        background-color: pink !important;
                    }
                }
            }
        }

        &.productTable {
            height: 460px;

            /deep/.el-table {

                td {
                    padding: 0;

                    .cell {
                        padding: 0;
                        line-height: 32px;
                    }
                }
            }
        }
    }
}
</style>